
/**
 * Handles metric/imperial value change
 * Used e.g. in product size list and technical manual downloads.
 *
 * @usage

  <div data-unit-system-container>
    <button class="active" data-unit-system-toggle="metric">Show metric</button>
    <button data-unit-system-toggle="imperial">Show imperial</button>

    <div class="is-metric">Width: 205mm</div>
    <div class="is-imperial" hidden>Width: 8"</div>
  </div>
 */

export default class UnitSystemToggle {
  #dom: {
    root: HTMLElement;
    buttons: NodeListOf<HTMLElement>;
  };

  types = ['metric', 'imperial'];

  constructor(element: HTMLElement) {
    this.#dom = {
      root: element,
      buttons: element.querySelectorAll('[data-unit-system-toggle]'),
    };

    this.#dom.buttons.forEach((button) => {
      button.addEventListener('click', this.onUnitSystemChange.bind(this));
    });

    console.log('UnitSystemToggle.init()');
  }

  onUnitSystemChange(event: Event) {
    const target = event.target as HTMLElement;
    const type = target.dataset.unitSystemToggle;

    if(type && this.types.includes(type)) {
      const elements = this.#dom.root.querySelectorAll('.is-metric, .is-imperial') as NodeListOf<HTMLElement>;
      elements.forEach((el) => {
        el.hidden = !el.classList.contains(`is-${type}`);
      });

      this.#dom.buttons.forEach((button) => {
        button.classList.toggle('active', button.dataset.unitSystemToggle === type);
      });
    }
  }
}
